export function validarData(valor) {
  // Verifica se a entrada é uma string
  if (typeof valor !== 'string') {
    return false
  }

  // Verifica formato da data: dd/mm/aaaa
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
    return false
  }

  // Divide a data
  const partesData = valor.split('/')
  const dia = parseInt(partesData[0], 10)
  const mes = parseInt(partesData[1], 10)
  const ano = parseInt(partesData[2], 10)

  // Dias de cada mês
  const diasNoMes = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  // Ajuste para ano bissexto
  if (ano % 400 === 0 || (ano % 4 === 0 && ano % 100 !== 0)) {
    diasNoMes[2] = 29
  }

  // Verifica validade do mês e dia
  if (mes < 1 || mes > 12 || dia < 1 || dia > diasNoMes[mes]) {
    return false
  }

  // Converte para objeto Date (atenção: meses em JS começam do 0)
  const dataNascimento = new Date(ano, mes - 1, dia)

  // Pega a data de hoje (sem hora)
  const hoje = new Date()
  hoje.setHours(0, 0, 0, 0)

  // Verifica se a data é no futuro
  if (dataNascimento > hoje) {
    return false
  }
  

  // Se chegou até aqui, é uma data válida e não está no futuro
  return true
}

export function validarTelefone(telefone) {
  // Verifica se é string e tem exatamente 11 dígitos numéricos
  if (typeof telefone !== 'string' || !/^\d{11}$/.test(telefone)) {
    return false
  }

  const ddd = parseInt(telefone.substring(0, 2), 10)

  // Valida se DDD está entre 11 e 99
  if (ddd < 11 || ddd > 99) {
    return false
  }

  // Número válido (não importa se começa com 9, 8, 7...)
  return true
}

export function validarEmail(email) {
  // Verifica se é uma string
  if (typeof email !== 'string') {
    return false;
  }

  // Verifica se o e-mail segue o formato básico de e-mail
  // Exemplo: algo@dominio.com.br
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return regexEmail.test(email);
}

export function validarNome(nome) {
  // Verifica se é uma string
  if (typeof nome !== 'string') {
    return false;
  }

  // Remove espaços extras
  const nomeLimpo = nome.trim();

  // Verifica se o nome tem pelo menos 2 caracteres
  if (nomeLimpo.length < 2) {
    return false;
  }

  // Verifica se o nome contém apenas letras, espaços e acentos
  const regexNome = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
  if (!regexNome.test(nomeLimpo)) {
    return false;
  }

  // precisa ter pelo menos dois nomes
  const partes = nomeLimpo.split(/\s+/);
  if (partes.length < 2) {
    alert('Por favor, informe seu nome completo (nome e sobrenome).');
    return false;
  }

  return true;
}

export function validarNomeMae(nome) {
  // Verifica se é uma string
  if (typeof nome !== 'string') {
    return false;
  }

  // Remove espaços extras
  const nomeLimpo = nome.trim();

  // Verifica se o nome tem pelo menos 2 caracteres
  if (nomeLimpo.length < 2) {
    return false;
  }

  // Verifica se o nome contém apenas letras, espaços e acentos
  const regexNome = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
  if (!regexNome.test(nomeLimpo)) {
    return false;
  }

  // precisa ter pelo menos dois nomes
  const partes = nomeLimpo.split(/\s+/);
  if (partes.length < 2) {
    alert('Por favor, informe o nome completo da genitora (nome e sobrenome).');
    return false;
  }

  return true;
}


export function validarArquivoPDF(arquivo) {
  // Verifica se foi passado um File
  if (!(arquivo instanceof File)) {
    return false;
  }

  // Verifica o tipo MIME
  return arquivo.type === 'application/pdf';
}
